import { gql } from '@apollo/client'

export const GENERATE_HEALTH_DATA_REPORT_PDF = gql`
  mutation generateHealthDataReportPdf($id: ID!) {
    generateHealthDataReportPdf(id: $id) {
      id
      pdfUrl
    }
  }
`
